<div class="toggle-group" *ngIf="viewportsConfig?.grids?.length > 0">
	<div
		class="btn"
		*ngFor="let viewport of viewportsConfig.grids"
		(click)="resize(viewport.index)"
		[ngClass]="{ 'btn-secondary': viewport === this.viewportsConfig.currentViewport() }"
	>
		{{ viewport.label }}
	</div>
</div>
